import React from 'react';
import { useLoading } from '../stores/loadingStore';

export const LoadingOverlay: React.FC = () => {
  const { isLoading, loadingText } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-bg-primary rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500" />
        {loadingText && (
          <p className="text-text-primary text-sm">{loadingText}</p>
        )}
      </div>
    </div>
  );
};